import { useCallback, useSyncExternalStore } from "react";

const STORAGE_KEY = "pm-view-customizations";

const listeners = new Set<() => void>();

function emitChange(): void {
  for (const listener of listeners) {
    listener();
  }
}

function subscribe(callback: () => void): () => void {
  listeners.add(callback);
  return () => listeners.delete(callback);
}

function getSnapshot(): boolean {
  return localStorage.getItem(STORAGE_KEY) === "true";
}

export function useViewCustomizations(): [boolean, () => void] {
  const isEnabled = useSyncExternalStore(subscribe, getSnapshot);

  const toggle = useCallback((): void => {
    const next = !getSnapshot();
    localStorage.setItem(STORAGE_KEY, String(next));
    emitChange();
  }, []);

  return [isEnabled, toggle];
}
